const glassyBackground = {
  backgroundColor: "rgba(255,255,255,0.5)",
  backdropFilter: "blur(4px)",
  background: `linear-gradient(120deg, rgba(255,255,255, 0.5) 0%, rgba(255,255,255, 0.8) 100%)`,
  borderRadius: 2,
};

export default glassyBackground;
